import {orderBy, pick} from 'lodash'
import React from 'react'
import Modal from 'react-modal'
import TabBar from './tab-bar'
import Text from 'react-text'
import {Context} from 'context'
import {isEmptyOrWhiteSpace} from 'helpers/utils'
import GroupsStep from './groups-step'
import DateStep from './date-step'
import {scheduleComment} from 'context/post'
import {faTimesCircle} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"

import './index.styl'

function Buttons ({left, right}) {
  return (
    <div className="buttons" style={{display: "flex"}}>
      <div style={{flexGrow: 1}} />
      <button disabled={!left.enabled} className={left.label} onClick={left.onClick}>
        <Text id={`${left.label}_label`} />
      </button>
      <button disabled={!right.enabled} className={right.label} onClick={right.onClick}>
        <Text id={`${right.label}_label`} />
      </button>
    </div>
  )
}

export default class ScheduleLesson extends React.Component {

  static contextType = Context

  constructor (props) {
    super(props)
    const setState = this.setState.bind(this)
    this.state = {
      date: props.date || new Date(),
      message: props.message || "",
      activeTab: props.activeTab,
      selectedGroup: props.selectedGroup,
      studentList: props.studentList || [],
      selectedStudents: props.selectedStudents || [],
      isOpen: true,
      setState
    }
  }


  render () {

    const context = this.context
    const {setState, activeTab, isOpen} = this.state
    const {lessons, lesson: lessonId} = context

    const save = () => {
      const {course} = this.state.selectedGroup
      return scheduleComment({
        subject: course.substring(0,2),
        language: context.languageId,
        students: this.state.selectedStudents,
        action: context.action,
        date: this.state.date,
        message: this.state.message,
      }).then(() => context.setState({eventUpdates: context.eventUpdates + 1}, close))
    }

    const previous = () => setState({activeTab: 'groups'})
    const next = () => setState({activeTab: 'date'})
    const close = () => setState({isOpen: false})
    const navigateOut = () => context.navigate({}, context.match.path.replace(/\/:action.*$/,''), {preserveQuery: true})
    const canSave = this.state.selectedStudents.length > 0 && !isEmptyOrWhiteSpace(this.state.message)

    return (
      <Modal
        isOpen={isOpen}
        onAfterClose={navigateOut}
        onRequestClose={close}
        contentLabel=""
        className="schedule-comment-wrapper"
        appElement={document.querySelector('#root')}
        closeTimeoutMS={800}
        >
          <div className="schedule-comment">
            <div className="title">
              <div className="label">
                <Text id="comment" />
              </div>
              <div className="close" onClick={() => close()}>
                <FontAwesomeIcon icon={faTimesCircle} />
              </div>
            </div>
            <TabBar {...{activeTab, setState}} />
            <div className="tab-content">
              {activeTab == 'groups' && (
                <React.Fragment>
                  <GroupsStep {...pick(this.state, ['selectedGroup', 'studentList', 'selectedStudents', 'setState'])} />
                  <Buttons
                    left={{label: 'cancel', onClick: close, enabled: true}}
                    right={{label: 'continue', onClick: next, enabled: true}}
                  />
                </React.Fragment>
              )}
              {activeTab == 'date' && (
                <React.Fragment>
                  <DateStep {...pick(this.state, ['date', 'setState', 'message'])} />
                  <Buttons
                    left={{label: 'back', onClick: previous, enabled: true}}
                    right={{label: 'save', onClick: save, enabled: canSave}}
                  />
                </React.Fragment>
              )}
            </div>
          </div>
        </Modal>
    )
  }
}
